/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY, finalize, Observable, tap } from 'rxjs';
import { IPostListingFilterModel } from '../../../../models/post.model';
import { IUserModel } from '../../../../models/user.model';
import { GroupsService } from '../../../../services/api/groups/groups.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-group-member-popup',
    standalone: false,
    templateUrl: './group-member-popup.component.html',
    styleUrl: './group-member-popup.component.scss',
})
export class GroupMemberPopupComponent extends BasePopupComponent {
    protected membersData = signal<IUserModel[]>([]);
    protected totalMembers = signal<number | null>(null);
    protected isInitialLoading = signal<boolean>(true); // For skeleton loader
    private page = 1;
    private size = 20;
    private allLoaded = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: any,
        protected override dialogRef: MatDialogRef<GroupMemberPopupComponent>,
        private groupsService: GroupsService,
        private loaderService: LoaderService,
        private dialog: MatDialog,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.loadMembers(true).subscribe();
    }

    protected onScroll(): void {
        this.loadMembers(false).subscribe();
    }

    protected loadMembers(
        reset = false,
        filter?: IPostListingFilterModel,
    ): Observable<{ total: number; result: IUserModel[] }> {
        if (this.allLoaded && !reset) {
            return EMPTY;
        }

        if (reset) {
            this.page = 1;
            this.allLoaded = false;
            this.membersData.set([]);
            this.isInitialLoading.set(true);
        }

        this.loaderService.show();
        return this.groupsService
            .getGroupMembersListing(Number(this.data.groupId), { ...filter, page: this.page, size: this.size })
            .pipe(
                tap((response) => {
                    this.totalMembers.set(response.total);
                    this.membersData.update((prev) => [...prev, ...response.result]);
                    if (response.result.length < this.size) {
                        this.allLoaded = true;
                    } else {
                        this.page++;
                    }
                }),
                catchError((error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                    console.error('Error getting group members listing:', error);
                    return EMPTY;
                }),
                finalize(() => {
                    this.isInitialLoading.set(false);
                    this.loaderService.hide();
                }),
            );
    }
}
